export const taskTypes = ["FAX_TASK", "FAX_FAIL", "PHONE_TASK"];
export const prescriberEntityType = "PRESCRIBER";